import React, {Component} from 'react';
import {Toast,List,Picker,DatePicker,InputItem} from 'antd-mobile';
import './style.less';
import {connect} from "react-redux";
import {getSation,getDistancePrice,commitOrder,commitEditOrder} from "../../service/shuntService";
const now = new Date();
let porpStartAddress = '';//具体的用户选择的地址
let startAddressPoint = '';//用户选择的地址的经纬度
let stationId = '';//起止点id
let shuntName = '';//起止点名称
let passagerName = '';//乘客姓名
let phone = '';//乘客电话
let startTime = '';
let startPoint = '';
let startCity = '';
let startCityPosition = '';
let endCityPosition = '';
let orderDataFlag = false;
let  shuntType;
@connect(
    state => ({userInfo: state.userInfo}),
)

export default class OrderShunt extends Component {
    constructor(props) {
        super(props);
        console.log(props)
        this.state = {
            shuntData:[],
            shunt:shuntName ? shuntName : '',
            // startTime:this.props.location.state.orderData ? this.props.location.state.orderData.shiftTime : '',
            startTime:startTime ? startTime : '',
            price:0,
            name:passagerName ? passagerName : '',
            phone:phone ? phone : '',
            startPoint:startPoint ? startPoint : '',//出发起止点的经纬度
            startAddressPoint:startAddressPoint ? startAddressPoint : '',//用户选择的出发地址的经纬度
            stationId:stationId  ? stationId:'',
            startAddress:porpStartAddress != '' ? porpStartAddress :'',
            startCity:startCity ? startCity : '',
            startCityPosition:startCityPosition ? startCityPosition : '',
            endCityPosition:endCityPosition ? endCityPosition : '',
        };
        this._returnAddressResult = this._returnAddressResult.bind(this);
        this._toChooseAddress = this._toChooseAddress.bind(this);
    }

    componentDidMount() {
        if(this.props.location.shuntType && this.props.location.shuntType.shuntType){
            shuntType = this.props.location.shuntType.shuntType;
        }
        //设置默认值为1，表示从主页跳转过来的分流
        if(!shuntType){
            shuntType = 1;//设置一个默认值为1
        }
        if(this.props.location.state !== undefined){
            const orderData = this.props.location.state.orderData;
            orderDataFlag = true;
            if(orderData.orderType == "送"){
                orderData.startAddress = orderData.endAddress;
            }
            if(startAddressPoint!== ""){
                orderData.startAddress = porpStartAddress;
                orderData.addressLocation = startAddressPoint;
            }
            // porpStartAddress = orderData.startAddress;
            this.setState({
                stationId:orderData.vicinageStationId,
                shunt:orderData.vicinageStationName.split(),//起止点名字
                startPoint:orderData.vicinageStationLacation,//起止点经纬度
                // startAddress:orderData.orderType == "接" ? orderData.startAddress : orderData.endAddress,//出发地址
                startAddress:orderData.startAddress,//出发地址
                startAddressPoint:orderData.addressLocation,//出发经纬度
                startCityPosition:orderData.shiftStartName,//出发城市
                endCityPosition:orderData.shiftEndName,//到达城市
                startTime:new Date(orderData.shiftTime),//行程出发时间
                phone:orderData.userPhoneNum,//联系电话
                startCity:orderData.shiftStartName,
            });
            porpStartAddress = '';
            startAddressPoint = '';
            shuntName = '';
            this.getstation();
            let params = {
                "token":this.props.userInfo.token,
                "data": {
                    "startLocation": orderData.orderType == "接" ? orderData.addressLocation : orderData.vicinageStationLacation,
                    "endLocation":  orderData.orderType == "接" ? orderData.vicinageStationLacation :orderData.addressLocation,
                    "orderType": orderData.orderType == "接" ? 0 : 1,
                }
            };
            getDistancePrice(params).then((res) => {
                if (res.data.code === '0000') {
                    this.setState({price:res.data.data,})
                }
                else {
                    Toast.info(res.data.msg);
                }
            })
        }else{
            this.getstation();
            if(this.state.startAddress != ''&& this.state.shunt != ''){
                this.getPrice();
            } else{
                this.setState({ price:0 })
            }
            startAddressPoint = '';
            porpStartAddress = '';
            // stationId = '';
            shuntName = '';
            passagerName = '';
            startTime = '';
            phone = '';
            startCityPosition = '';
            endCityPosition = '';
            // startPoint = '';
            this.setState({
                phone:'',
                startTime:'',
                // startAddressPoint: '',
                // shunt:'',
                startCityPosition:'',
                endCityPosition:'',
                // startAddress:'',
            })
        }
    }
    
    //获取分流起止点信息
    getstation = () => {
        let params = {
            "token":this.props.userInfo.token,
          };
        getSation(params).then((res) => {
            if (res.data.code === '0000') {
                let shuntData = [];
                let data = res.data.data;
                for(let i in data){
                  let temp = data[i];
                  shuntData.push({
                    label:temp.sationName,
                    value:temp.sationName,
                    stationId:temp.stationId,
                    location:temp.stationLocation,
                    sationDisplayName:temp.sationDisplayName
                  })
                }
                this.setState({
                    shuntData:shuntData,
                })
            }
            else {
                Toast.info(res.data.msg);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    //根据起始地址经纬度获取理论价格
    getPrice = () => {
        let params = {
            "token":this.props.userInfo.token,
            "data": {
                "startLocation": this.props.type == 0 ? startAddressPoint : this.state.startPoint,
                "endLocation":  this.props.type == 0 ? this.state.startPoint :startAddressPoint,
                "orderType": this.props.type,
            }
          }
        getDistancePrice(params)
            .then((res) => {
                if (res.data.code === '0000') {
                    this.setState({
                        price:res.data.data,
                    })
                
                }
                else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
            console.log(error);
        });
    }
    inputChange = key =>(e) =>{
        passagerName = e;
        this.setState({ [key]: passagerName })
    };
    Change = key =>(e) =>{
        phone = e;
        this.setState({ [key]: phone })
    };
    cityChange = key =>(e) =>{
        this.setState({ [key]:e })
    }
    startTimeChange = key =>(e) =>{
        startTime = e;
        this.setState({ [key]: startTime })
    };
    _toChooseAddress(type){
        if(this.state.shunt === ''){
            Toast.info('请先选择分流点！')
            return
        }
        var datas = {type:type,shuntType:shuntType,returnData:this._returnAddressResult.bind(this)};
        var historyData = {
            pathname:'/selectAddress',
        };
            historyData.startCity=this.state.startCity;
            historyData.startPoint=this.state.startPoint;
            historyData.stationId=this.state.stationId;
            historyData.shunt=this.state.shunt;
            historyData.startTime=this.state.startTime;
            historyData.phone=this.state.phone;
            historyData.startCityPosition=this.state.startCityPosition;
            historyData.endCityPosition=this.state.endCityPosition;
            historyData.datas=datas;
            historyData.shuntType= shuntType;
        this.props.goPage(historyData)
       
    }
    _returnAddressResult(datas){
        startAddressPoint = datas.point.lat + '_' + datas.point.lng;
        phone = datas.phone;
        startTime = datas.startTime;
        shuntName = datas.shunt;
        startCityPosition = datas.startCityPosition;
        endCityPosition = datas.endCityPosition;
        let address = datas.address;
        porpStartAddress = address;
        shuntType = datas.shuntType;
    }
   
    commitOrder = () => {
        var reg = /[\u4E00-\u9FA5\uF900-\uFA2D]/; 
        if(this.state.shunt == ''){
            Toast.info('分流点不能为空')
            return
        }
        if(this.state.startAddress == ''){
            Toast.info('分流地址不能为空')
            return
        }
        if(this.state.startCityPosition == ''){
            Toast.info('出发城市不能为空')
            return
        }
        if(this.state.endCityPosition == ''){
            Toast.info('到达城市不能为空')
            return
        }
        if(this.state.phone == ''){
            Toast.info('联系电话不能为空')
            return
        }
        if(this.state.startTime == ''){
            Toast.info('出发时间不能为空')
            return
        }
        if(!reg.test(this.state.startCityPosition) || !reg.test(this.state.endCityPosition)){
            Toast.info('只能输入中文城市名！')
            return
        }
        
        if(this.props.location.state!== undefined){
            const orderData = this.props.location.state.orderData;
            let params = {
                token: this.props.userInfo.token,
                data: {
                    "orderType": orderData.orderType == "接" ? 0 : 1,
                    "startAddress":orderData.orderType == "接" ? this.state.startAddress: this.state.shunt.toString(),
                    "stationId":this.state.stationId,
                    "startAddressLocation":orderData.orderType == "接" ? this.state.startAddressPoint : this.state.startPoint,
                    "endAddress":orderData.orderType == "接" ?  this.state.shunt.toString() : this.state.startAddress,
                    "endAddressLcation": orderData.orderType == "接" ? this.state.startPoint :this.state.startAddressPoint,
                    "passagerPhone": this.state.phone.replace(/\s+/g,""),
                    "interorderStarttime":this.state.startTime,
                    "startAddressOfShift":this.state.startCityPosition,
                    "endAddressOfShift":this.state.endCityPosition,
                    "oldShuntOrderId":orderData.shuntOrderId,
                }
            };
            Toast.loading("正在加载",0);
            commitEditOrder(params).then((res) => {
                if (res.data.code === '0000') {
                    Toast.info('修改成功',2,()=> this.props.history.goBack());
                } else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
                console.log(error);
            });

        }else{
            let params = {
                token: this.props.userInfo.token,
                "data": {
                    "orderType": this.props.type,
                    "startAddress":this.props.type == 0 ? this.state.startAddress: this.state.shunt.toString(),
                    "stationId":this.state.stationId,
                    "startAddressLocation":this.props.type == 0 ? this.state.startAddressPoint : this.state.startPoint,
                    "endAddress":this.props.type == 0 ?  this.state.shunt.toString() : this.state.startAddress,
                    "endAddressLcation": this.props.type == 0 ? this.state.startPoint :this.state.startAddressPoint,
                    "passagerPhone": this.state.phone.replace(/\s+/g,""),
                    // "interorderStarttime":moment(this.state.startTime).format('YYYY-MM-DD HH:ss:mm')
                    "interorderStarttime":this.state.startTime,
                    "startAddressOfShift":this.state.startCityPosition,
                    "endAddressOfShift":this.state.endCityPosition,
                    "operatorType":shuntType,
                }
            };
            Toast.loading("正在加载",0);
            commitOrder(params).then((res) => {
                if (res.data.code === '0000') {
                    Toast.hide();
                    Toast.info('添加分流订单成功！');
                    this.setState({
                        shunt:'',
                        phone:'',
                        name:'',
                        startTime:'',
                        startAddress:'',
                        startCityPosition:'',
                        endCityPosition:'',
                        price:0,
                    })
                } else {
                    Toast.info(res.data.msg);
                }
            }).catch(function (error) {
                console.log(error);
            });
        }


    };
    addActive = (v) => {
        let datas = this.state.shuntData;
        let labels = [];
        datas.forEach(e =>{
            labels.push(e.label)
        })
        startCity = datas[labels.indexOf(v[0])].sationDisplayName;
        startPoint = datas[labels.indexOf(v[0])].location;
        stationId = datas[labels.indexOf(v[0])].stationId;
        shuntName = v;
        this.setState({
            startAddressPoint:startPoint,
            startPoint:startPoint,
            stationId:stationId,
            shunt:v,
            startCity:startCity,
            startAddress:''
        });
    }
    render() {
        return (
            <div className="orderShunt">
                <List className="address">
                    <Picker
                        cols={1}
                        extra={this.state.shunt ? this.state.shunt :(this.props.type == 1 ? <span className="fontSize26">选择用户分流点</span> :  <span className="fontSize26">选择用户要到达的分流点</span> )}
                        data={this.state.shuntData}
                        value={this.state.shunt}
                        onOk={(v)=>this.addActive(v)}
                    >
                        <List.Item arrow="horizontal"><span className="fontSize28">选择分流点</span></List.Item>
                    </Picker>
                   <List.Item 
                        onClick={this.props.type == 0 ? this._toChooseAddress.bind(this,'start') :this._toChooseAddress.bind(this,'end') }
                        thumb={this.props.type == 0 ? <div className="addressTitle">乘客出发地</div> : <div className="addressTitle">乘客目的地</div> }
                        arrow="horizontal">
                            {this.state.startAddress ? <span  className="span">{this.state.startAddress}</span> :(this.props.type == 0 ? <span className="fontSize26 paddingLeft10">请选择用户所在位置</span>:<span className="fontSize26 paddingLeft10">请选择用户需要到达的位置</span>)}
                    </List.Item>
                   {/*  <InputItem
                        className="inp"
                        placeholder="请输入乘客姓名"
                        value={this.state.name}
                        onChange={this.inputChange("name")}
                   >乘客姓名</InputItem> */}
                    <div style={{display:'flex'}}>
                        <InputItem
                        className="inp"
                        placeholder="出发城市"
                        value={this.state.startCityPosition}
                        onChange={this.cityChange("startCityPosition")}
                        type="text"
                            ><span className="fontSize28">乘车起止区域</span></InputItem>
                        <span className="reach">到</span>
                        <InputItem
                        className="inp"
                        placeholder="到达城市"
                        value={this.state.endCityPosition}
                        onChange={this.cityChange("endCityPosition")}
                        type="text"
                            ></InputItem>
                    </div>
                    <DatePicker
                        value={this.state.startTime}
                        extra={<span className="colorGray">请选择出发时间</span>}
                        onOk={(v)=>this.setState({startTime:v})}
                        defaultDate={new Date()}
                        minDate={new Date()}
                        maxDate={new Date(+now + 5184000000)}
                        onChange={this.startTimeChange('startTime')}
                    >
                        <List.Item arrow="horizontal"><span className="fontSize28">{this.props.type == 0 ? '行程出发时间': '行程到达时间'}</span></List.Item>
                    </DatePicker>
                    <InputItem
                        className="inp"
                        placeholder="请输入乘客联系电话"
                        value={this.state.phone}
                        onChange={this.Change("phone")}
                        style={{textAlign:'left',paddingLeft:'10px'}}
                        className="paddingLeft10"
                        type="phone"
                    ><span className="fontSize28">联系电话</span></InputItem>
                </List>
                <div className="priceInfo">费用明细</div>
                <div className="totalAmount">
                    <div className="amount">
                        <span>总金额</span>
                        <span>¥{this.state.price}</span>
                    </div>
                    <p>请在行程管理中查看行程出行信息！</p>
                    <div className="btn" onClick={()=>this.commitOrder()}>提交</div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/OrderShunt/index.js